import React from 'react';

const Scholarship = () => {
  return (
    <div>
      Scholarship
      Scholarship
    </div>
  );
}

export default Scholarship;
